module.exports = __webpack_public_path__ + "static/calatonStudioDesktop@2x-79fd700cfbe7a655bbf752a279162b8c.jpg";